import React from 'react';
import { OverviewChrome } from '../boardStates';
import { usePortalCopy } from '../PortalUi';
import { formatPortalDate } from '../api/portalService';

/**
 * `sentOn` es `created_at` de la solicitud. Sin él (mock del prototipo) se usa
 * la fecha fija del fixture; con él, la real. El prototipo traía «24 de agosto»
 * y en vivo eso era mentira en toda solicitud.
 */
export function Stepper({ chrome, sentOn }: { chrome: OverviewChrome; sentOn?: string | null }) {
  const t = usePortalCopy();
  const sentSub = sentOn ? formatPortalDate(sentOn) : t('stepSentSub');
  const labels = [
    { title: t('stepSent'), sub: sentSub },
    { title: t('stepReqs'), sub: t('stepReqsSub') },
    { title: t('stepReview'), sub: t('stepReviewSub') },
    { title: t('stepDecision'), sub: t('stepDecisionSub') },
  ];
  return (
    <div className="stepper" id="ov-steps">
      {labels.map((step, i) => {
        const kind = chrome.steps[i];
        const active = kind === 'cur' || kind === 'warn';
        return (
          <div
            key={step.title}
            className={`step ${kind}`.trim()}
            aria-current={active ? 'step' : undefined}
          >
            <b>{step.title}</b>
            <span>{step.sub}</span>
          </div>
        );
      })}
    </div>
  );
}
